module.exports = __webpack_public_path__ + "img/elijah_campbell.462c30c0.png";